import { render } from "./TableHeader.vue?vue&type=template&id=01435b60"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"
script.render = render

export default script